/*
 * @Description: 功能描述
 * @Author: yy
 * @Date: 2019-05-31 14:47:30
 * @LastEditors: yy
 * @LastEditTime: 2019-09-03 15:25:17
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './RestoreArt.css';
import cx from 'classnames';
import moment from 'moment'
import Link from '../Link';
import kolV from './kolV.png'



class RestoreArt extends React.Component {
  constructor(props){
    super(props)
    this.state={
      commonArticle:[],
      kolArticle:[],
      loading:false,
      m:moment,
      delBtn:false,
    }
    this.brandRender=this.brandRender.bind(this)
    this.fromRender=this.fromRender.bind(this)
    this.getArtJson=this.getArtJson.bind(this)
    this.showDelBtn=this.showDelBtn.bind(this)
    this.hideDelBtn=this.hideDelBtn.bind(this)
    this.delArt=this.delArt.bind(this)
    this.delBrand=this.delBrand.bind(this)
    this.changeBrandEmotion=this.changeBrandEmotion.bind(this)
  }

  changeBrandEmotion=(i,artItem,index)=>{

    let like
    if(index==0){
      like='推荐'
    }else if(index==1){
      like='好感'
    }else if(index==2){
      like='中立'
    }else if(index==3){
      like='差评'
    }else if(index==4){
      like='反感'
    }

    if( confirm(`确定将 ${i.brandName} 品牌的好感度设置为 ${like}？`) ){
      console.log(artItem.url,artItem.from)
      let m=artItem.date.substring(0,2)
      let d=artItem.date.substring(4,6)
      let artDate =moment(`${m}-${d}`,'MM-DD').format('YYYY-MM-DD')

      let url=`/digitalAssets/article/update_brand_emotion?url=${encodeURIComponent(artItem.url)}&platform=${artItem.from}&article_date=${artDate}&brand_id=${i.brandId}&emotion=${index}`
      const myInit = {
        method: 'GET',
        credentials: 'include', 
        mode: 'cors',
        cache: 'no-cache' 
      };
      fetch(url,myInit).then(response => response.json())
      .then(data => {
        console.log(data,'····更改品牌好感···')
        this.setState({
           
        })
        // console.log('ss',this.state.commonArticle)
      })
      .catch(e => console.log("Oops, error", e))

      this.getArtJson(this.props)
    
    }
  }

  delBrand=(i,artItem)=>{
    // console.log(i.brandId)
    // console.log(artItem)
    if( confirm(`确定删除  ${i.brandName} 品牌？ `) ){
      console.log(artItem.url,artItem.from)
      let m=artItem.date.substring(0,2)
      let d=artItem.date.substring(3,5)
      let artDate =moment(`${m}-${d}`,'MM-DD').format('YYYY-MM-DD')

      let url=`/digitalAssets/article/delete_brand?url=${encodeURIComponent(artItem.url)}&platform=${artItem.from}&article_date=${artDate}&brand_id=${i.brandId}`
      const myInit = {
        method: 'GET',
        credentials: 'include', 
        mode: 'cors',
        cache: 'no-cache' 
      };
      fetch(url,myInit).then(response => response.json())
      .then(data => {
        console.log(data,'····删除品牌数据···')
        this.setState({
           
        })
        // console.log('ss',this.state.commonArticle)
      })
      .catch(e => console.log("Oops, error", e))

      this.getArtJson(this.props)
    
    }
  }



  delArt=(i)=>{
    // alert(`删除！${i.txt}`)
    if( confirm(`确定恢复文章 ：${i.txt}`) ){
      let m=i.date.substring(0,2)
      let d=i.date.substring(3,5)
      let artDate =moment(`${m}-${d}`,'MM-DD').format('YYYY-MM-DD')

      console.log(m,d,artDate)
      let url=`/digitalAssets/reshow_article?url=${encodeURIComponent(i.url)}&platform=${i.from}&article_date=${artDate}`
      console.log(url)
      
      const myInit = {
        method: 'GET',
        credentials: 'include', 
        mode: 'cors',
        cache: 'no-cache' 
      };
      fetch(url,myInit).then(response => response.json())
      .then(data => {
        console.log(data,'······修改数据···')
        this.setState({
           
        })
        // console.log('ss',this.state.commonArticle)
      })
      .catch(e => console.log("Oops, error", e))

      alert('文章正在删除请稍等')
      this.getArtJson(this.props)
    
    }
  

  }
  showDelBtn=()=>{
    // console.log('展示删除btn')
    // this.setState({delBtn:true})
  }
  hideDelBtn=()=>{
    // console.log('隐藏删除btn')
    // this.setState({delBtn:true})
    
  }


  getArtJson=(props)=>{
    // console.log(items,'文章数据的items`````````````````````')
    // console.log(props,'这是props')
    const {m}=this.state
    const {time,from}=props
    this.setState({
      commonArticle:[],
      kolArticle:[]
    })

    let platform
    if(from==0){
      platform='wx'
    }else if(from==1){
      platform='wb'
    }else if(from==2){
      platform='zh'
    }else if(from==3){
      platform='tt'
    }else if(from==4){
      platform='wk'
    }

    // const start=m(`${time.substring(0,10)}`,'YYYY-MM-DD').format('YYYY-MM-DD')
    // const end=m(`${time.substring(11,21)}`,'YYYY-MM-DD').format('YYYY-MM-DD')
    let url=`/digitalAssets/deleted_article_list?platform=${platform}&article_date=${time}`
    
    console.log(platform,time,url)
    


    const myInit = {
      method: 'GET',
      credentials: 'include', 
      mode: 'cors',
      cache: 'no-cache' 
    };
    fetch(url,myInit).then(response => response.json())
    .then(data => {
      console.log(data,'删除的文章文章文章数据····')
      this.setState({
          commonArticle:data.topDocList,
          kolArticle:data.kolDocList,
          loading:false,
      })
      // console.log('ss',this.state.commonArticle)
    })
    .catch(e => console.log("Oops, error", e))
  }

  componentDidMount() {
    console.log(this.props)
    this.getArtJson(this.props)
  }


    componentWillReceiveProps(nextProps) {
      let r

      if(this.props.time!=nextProps.time){
        this.getArtJson(nextProps)
      }else if(this.props.from!=nextProps.from){
        this.getArtJson(nextProps)
      }else{
          return false
      }
      
      
    }


    // componentDidUpdate(prevProps,prevState){
    //     // console.log('文章···········即将更新',prevProps,this.props,prevProps!=this.props,this.props==prevProps,prevProps.industry==this.props.industry,'《行业对比《',prevProps.time==this.props.time,'《时间对比《')
    //     // if(prevProps!=this.props){
    //     //   console.log('即将执行文章更新')
    //     //   this.getArtJson(prevProps)
    //     // }
    //   if(prevProps.time!=this.props.time){
    //     console.log('时间不同')
    //   // this.getArtJson(nextProps)
    //     this.getArtJson(prevProps)
      
    //     return true
    //   }else if(prevProps.industry!=this.props.industry){
    //     console.log('行业不同')
    //   this.getArtJson(prevProps)
        
    //     return true
    //   }else if(prevProps.region!=this.props.region){
    //     this.getArtJson(prevProps)
      
    //     console.log('地区不同')
    //     return true
    //   }else if(prevProps.items!=this.props.items){
    //     this.getArtJson(prevProps)
      
    //     console.log('品牌不同')
    //     return true
    //   }else{
    //     console.log('不渲染')
    //     return false
    //   }
        
    // }

  fromRender=(item)=>{
    let from=item.from

      if(from=='wb'){
        return (
          <div className={s.postsInfo}>
            <div className={s.left}>
              <span className={s.postsAdd}>来源：微博</span>
              <span className={s.postsDate}>{item.date}</span>
            </div>
            <div className={s.right}>
              <span className={s.postsFlow}>
                <i className={s.postsIcon3}></i>
                <em className={s.postsNum}>转发：{item.repostsCount}</em>
              </span>
              <span className={s.postsFlow}>
                <i className={s.postsIcon5}></i>
                <em className={s.postsNum}>评论：{item.commentsCount}</em>
              </span>
              <span className={s.postsFlow}>
                <i className={s.postsIcon4}></i>
                <em className={s.postsNum}>点赞：{item.attitudesCount}</em>
              </span>
            </div>
          </div>
        )
      }else if(from=='wx'){
        return (
          <div className={s.postsInfo}>
            <div className={s.left}>
              <span className={s.postsAdd}>来源：微信</span>
              <span className={s.postsDate}>{item.date}</span>
            </div>
            <div className={s.right}>
              <span className={s.postsFlow}>
                <i className={s.postsIcon2}></i>
                <em className={s.postsNum}>阅读：{item.readCount>100000?'10W+':item.readCount}</em>
              </span>
              <span className={s.postsFlow}>
                <i className={s.postsIcon4}></i>
                <em className={s.postsNum}>在看：{item.attitudesCount}</em>
              </span>
            </div>
          </div>
        )
      }else if(from=='zh'){
        return (
          <div className={s.postsInfo}>
            <div className={s.left}>
              <span className={s.postsAdd}>来源：知乎</span>
              <span className={s.postsDate}>{item.date}</span>
            </div>
            <div className={s.right}>
              <span className={s.postsFlow}>
                <i className={s.postsIcon6}></i>
                <em className={s.postsNum}>赞同：{item.attitudesCount}</em>
              </span>
              <span className={s.postsFlow}>
                <i className={s.postsIcon5}></i>
                <em className={s.postsNum}>评论：{item.commentsCount}</em>
              </span>
            </div>
          </div>
        )
      }else if(from=='tt'){
        return (
          <div className={s.postsInfo}>
            <div className={s.left}>
              <span className={s.postsAdd}>来源：今日头条</span>
              <span className={s.postsDate}>{item.date}</span>
            </div>
            <div className={s.right}>
              <span className={s.postsFlow}>
                <i className={s.postsIcon2}></i>
                <em className={s.postsNum}>阅读：{item.readCount}</em>
              </span>
              <span className={s.postsFlow}>
                <i className={s.postsIcon5}></i>
                <em className={s.postsNum}>评论：{item.commentsCount}</em>
              </span>
            </div>
          </div>
        )
      }else if(from=='wk'){
        return (
          <div className={s.postsInfo}>
            <div className={s.left}>
              <span className={s.postsAdd}>来源：悟空问答</span>
              <span className={s.postsDate}>{item.date}</span>
            </div>
            <div className={s.right}>
              <span className={s.postsFlow}>
                <i className={s.postsIcon2}></i>
                <em className={s.postsNum}>阅读：{item.readCount}</em>
              </span>
              <span className={s.postsFlow}>
                <i className={s.postsIcon5}></i>
                <em className={s.postsNum}>评论：{item.commentsCount}</em>
              </span>
            </div>
          </div>
        )
      }
  }
  brandRender=(item)=>{
    
    
    if(item.brandList.length>3){
      item.brandList.length=3          
    }
    let artItem=item


    let ss=(emotion)=>{
      if(emotion==1){
        return s.brandLike1
      }else if(emotion==2){
        return s.brandLike2
      }else if(emotion==3){
        return s.brandLike3
      }else if(emotion==4){
        return s.brandLike4
      }else if(emotion==5){
        return s.brandLike5
      }
    }


    let clickEmotion=[
      'brandLike1',
      'brandLike2',
      'brandLike3',
      'brandLike4',
      'brandLike5',
    ]
    return (
      
      <ul className={s.postsBrandList}>
        {item.brandList.map((item,i)=>{
          return (
              <li className={s.postsBrand} key={i}>
                <span className={s.brandP} >
                    {/* <Link to={`/detail?brandName=${item.brandName}`}>{item.brandName}</Link> */}
                    {item.brandName}
                </span>
                <i className={s.brandImg} >
                    <img src={`/digitalAssets/resources/img/LOGO/${item.brandId}.png`}/>

                </i>
                <i className={ss(item.emotion)}></i>
                
              </li>        
            )          
          })
        }
      </ul>  
    )
    
    
  }

  render() {
    

    
    

    const {kolArticle,commonArticle}=this.state
    console.log(kolArticle,commonArticle)
    return (
      <div className={s.root}>
        

        <div className={cx(s.conFoot, s.clearfix)} id="floatShow">
          {/* <!--文章排行--> */}
        {commonArticle!=undefined?
          
          <div className={cx(s.fl, s.footRank)}>
            <span className={s.articleTit}>关键事件</span>
            <span className={s.int}>Hot Posts</span>
            <ul>
              {commonArticle.map((item,i)=>(
                <li key={i} className={s.postsItem}>
                  <span className={s.artDelBtn}  onClick={()=>this.delArt(item)}>恢复</span>
                  <div className={s.postsIndex}>{i+1}</div>
                  <div className={s.postsCon}>
                    <div className={s.postsHead}>
                      <a target='_blank' href={item.url} className={s.postsTxt}>{item.txt}</a>
                      {this.fromRender(item)}                    
                    </div>
                    <div className={s.postsFoot}>
                      <div className={s.postsInt}>关联品牌：</div>
                      {this.brandRender(item)}
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        :null}
          
          {/* <!--KOL排行--> */}
          {kolArticle!=undefined?
          
          <div className={s.footRank2}>
            <span className={s.articleTit}>KOL关联</span>
            <span className={s.int}>Involved KOLs</span>
            <ul>
              {kolArticle.map((item,i)=>(
                <li key={i} className={s.postsItem}>
                  <span className={s.artDelBtn}  onClick={()=>this.delArt(item)}>恢复</span>
                  <div className={s.postsIndex}>{i+1}</div>
                  <div className={s.postsCon}>
                    <div className={s.postsHead}>
                      <div className={s.userItem}>
                        <i className={s.userImg}><img src={item.kolImg}/><img src={kolV} className={s.kolV}/></i>
                        <a target='_blank' href={item.from=='wx'?'javascript:;':item.kolUrl} className={s.userName}>{item.kolName}</a>
                        <a target='_blank' href={item.url} className={s.postsTxt2}>{item.txt}</a>
                      </div>
                    {this.fromRender(item)}                    
                  </div>
                  <div className={s.postsFoot}>
                    <div className={s.postsInt}>关联品牌：</div>
                      {this.brandRender(item)}                    
                    </div>
                  </div>
                </li>
              ))}
              
              
            </ul>
          </div>

          :null}
          
        </div>

      </div>
    )

  }
}

export default withStyles(s)(RestoreArt);



// WEBPACK FOOTER //
// src/components/RestoreArt/RestoreArt.js